import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import OrderDetails from "../../components/Order/OrderDetails";

const OrderDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <OrderDetails />
      {/* <MultiOrderDetails /> */}
    </Layout>
  );
};

export default OrderDetailsPage;
